export default {
  home: {
    title: "Envie de faire quelque chose grand ?",
    description:
      "Rejoignez-nous pour aider tout le monde partout à accéder à l'énergie solaire - propre, gratuite et indépendante.",
  },
  values: {
    title: "Ce que nous recherchons",
    description:
      "Nous sommes une communauté d'engagement ou chacun partage et cultive l'audace, la perséverance et l'empathie dans notre petite équipe.",
    value1: {
      title: "Soyez les meilleurs",
      description:
        "Aspirez à l'excellence et atteignez des nouveaux sommets. Surmontez les défis avec détermination. Utilisez vos talents et recherchez la croissance. Incarnez le succès et l'amélioration continue.",
    },
    value2: {
      title: "Partagez tout ce que vous savez",
      description:
        "Adoptez l'échange de connaissances et la collaboration. Partagez votre expertise et vos idées. Créez un monde de connaissances accessibles. Cultivez la curiosité.",
    },
    value3: {
      title: "Toujours en apprentissage",
      description:
        "Soyez autodidacte ! Recherchez de nouvelles expériences. Envisagez les échecs comme des leçons. Adaptez-vous aux changements. Apprenez, grandissez et prospérez.",
    },
    value4: {
      title: "Soyez solidaire",
      description:
        "Créez un environnement bienveillant. Célébrez les réussites. Offrez votre aide. Favorisez l'empathie et les liens. Construisez la prospérité collective.",
    },
    value5: {
      title: "Assumez vos responsabilités",
      description:
        "Acceptez l'obligation de rendre des comptes. Assumez vos actes. Apprenez de vos erreurs. Reconnaissez l'impact de vos actions.",
    },
    value6: {
      title: "Vivez votre meilleure vie",
      description:
        "Reconnaissez l'importance du repos. Détendez-vous et rechargez vos batteries. Engagez-vous dans des activités joyeuses. Trouvez l'équilibre.",
    },
  },
  commitments: {
    FULL_TIME: "Temps plein",
    PART_TIME: "Temps partiel",
    INTERNSHIP: "Stage",
    CONTRACT: "Auto-entrepreneur",
    COFOUNDER: "Directeur⸱ice",
  },

  roles: {
    COFOUNDER: "Directeur⸱ice",
    PROGRAMMING: "Développeur⸱euse",
    CONTRACT: "Auto-entrepreneur",
    DESIGN: "Designeur⸱euse",
    MANAGEMENT: "Gérant⸱e",
    BUSINESS_DEVELOPMENT: "Développeur⸱euse d'affaires",
    SALES_AND_MARKETING: "Commercial⸱e",
    ADMINISTRATION: "Administratif",
  },
}
